export const COMPOSITE_CONSTS = {
    GET_CONTACT: "GET_CONTACT",
    UPDATE_CONTACT: "UPDATE_CONTACT",

    GET_REGIONS: "GET_REGIONS",
    GET_REGION_RESIDENCES: "GET_REGION_RESIDENCES",
    CLEAR_REGION_RESIDENCES: "CLEAR_REGION_RESIDENCES",

};
